import api from '@/services/api';

function createOrder(subscriptions) {
  return api().post('orders', subscriptions);
}

function updateOrder(order) {
  return api().put('orders', order);
}

function getOrdersFromCompanyId(companyId) {
  return api().get(`companies/${companyId}/orders?perPage=100&filters=subscriptions:empty:false`);
}

function getOrderFromId(id) {
  return api().get(`orders/${id}`);
}

function associationCompanyToOrder(orderId, companyId) {
  return api().post(`companies/${companyId}/orders`, { id: orderId });
}

function checkoutOrder(orderId, companyId) {
  return api().post(`orders/${orderId}/checkout`, { id: companyId });
}

function addSubscriptionsToOrder(orderId, subscriptions) {
  return api().put(`orders/${orderId}/subscriptions`, subscriptions);
}

function removeSubscriptionsFromOrder(orderId, subscriptionId) {
  return api().delete(`orders/${orderId}/subscriptions/${subscriptionId}`);
}

export {
  createOrder,
  updateOrder,
  checkoutOrder,
  getOrderFromId,
  getOrdersFromCompanyId,
  addSubscriptionsToOrder,
  removeSubscriptionsFromOrder,
  associationCompanyToOrder,
};
